import React from 'react';

interface CreditHistoryItem {
  date: string;
  type: string;
  details: string;
  analysis: string;
  status: string;
}

interface Step10Props {
  creditHistory: CreditHistoryItem[];
}

export default function Step10CreditHistory({ creditHistory }: Step10Props) {
  const getStatusBadge = (status: string) => {
    const styles: Record<string, string> = {
      approved: 'bg-green-100 text-green-700',
      rejected: 'bg-red-100 text-red-700',
    };
    return styles[status] || 'bg-gray-100 text-gray-700';
  };

  return (
    <div className="space-y-4">
      <div className="p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-700">
          Histori permohonan kredit sebelumnya untuk debitur ini akan ditampilkan di sini. Data ini
          akan diisi otomatis dari sistem.
        </p>
      </div>

      {creditHistory && creditHistory.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="w-full border">
            <thead className="bg-gray-50">
              <tr>
                <th className="p-3 text-left border text-sm font-medium">Tanggal</th>
                <th className="p-3 text-left border text-sm font-medium">Jenis Permohonan</th>
                <th className="p-3 text-left border text-sm font-medium">Identitas & Agunan</th>
                <th className="p-3 text-left border text-sm font-medium">Hasil Analisis</th>
                <th className="p-3 text-left border text-sm font-medium">Status</th>
              </tr>
            </thead>
            <tbody>
              {creditHistory.map((item, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="p-3 border text-sm">{item.date || '-'}</td>
                  <td className="p-3 border text-sm">{item.type || '-'}</td>
                  <td className="p-3 border text-sm">{item.details || '-'}</td>
                  <td className="p-3 border text-sm">{item.analysis || '-'}</td>
                  <td className="p-3 border">
                    <span
                      className={`px-2 py-1 rounded text-xs font-medium ${getStatusBadge(item.status)}`}
                    >
                      {item.status || '-'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="p-8 text-center text-gray-500 border-2 border-dashed rounded-lg">
          Belum ada riwayat permohonan kredit sebelumnya
        </div>
      )}
    </div>
  );
}
